import { UrlParamsType } from '@appTypes/urlParamsType';
import { CarModelType } from '@appTypes/carModelType';
import createAPIQuery from '@lib/createURLQueries';
import { ELBILGUIDE_ADDITIONAL_FILTERS } from './elbilguideConstants';

// `createAPIQuery` partial-applied with the elbilguiden page scope
// (fuelCategories: ['elektrisk']). Use this everywhere on the elbilguiden
// flow instead of passing the additional-filters object around.
const createElbilguideAPIQuery = (params?: UrlParamsType, ids?: CarModelType['slug'][] | CarModelType['id'][]) =>
  createAPIQuery(params, ELBILGUIDE_ADDITIONAL_FILTERS, ids);

export default createElbilguideAPIQuery;
